import React from "react";
import "./Article.scss";
import { IBlockElement } from "../../../types/IBlockElement";

export default function Article({ id, className, children, onClick, onChange }: IBlockElement) {
    return <article id={id} className={className} onClick={onClick} onChange={onChange}>{children}</article>;
}